import { render, staticRenderFns } from "./StandardizationConsultation.vue?vue&type=template&id=0082177d&scoped=true&"
import script from "./StandardizationConsultation.vue?vue&type=script&lang=js&"
export * from "./StandardizationConsultation.vue?vue&type=script&lang=js&"
import style0 from "./StandardizationConsultation.vue?vue&type=style&index=0&id=0082177d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082177d",
  null
  
)

export default component.exports